export const nursingConst = {
  path: "/single-programs/nursing",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ВЫСШЕЕ МЕДСЕСТРИНСКОЕ ДЕЛО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Высшее медсестринское дело — профессия, которая обеспечивает заботу и лидерство в медицине</h2>
      <p>
        Высшее медсестринское образование — это путь к углубленным знаниям и расширенным профессиональным возможностям. Современная
        медицинская сестра — это не только помощник врача, но и самостоятельный специалист, обладающий клиническим мышлением,
        управленческими навыками и способностью принимать решения в критических ситуациях.
      </p>
      <p>
        Программа ориентирована на подготовку лидеров сестринского дела, способных не только оказывать квалифицированную помощь пациентам,
        но и управлять медицинским персоналом, обучать коллег, внедрять современные подходы в систему здравоохранения.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Основы сестринского дела и клинической практики</li>
        <li>Внутренние болезни, хирургия, гериатрия и педиатрия</li>
        <li>Менеджмент в здравоохранении и управление медперсоналом</li>
        <li>Современные медицинские процедуры и стандарты ухода</li>
        <li>Этические и правовые аспекты сестринской практики</li>
        <li>Психология общения с пациентами и работа с семьями</li>
        <li>Доказательная медицина и основы научных исследований</li>
        <li>Профилактика и общественное здоровье</li>
      </ul>
      <p>В процессе обучения предусмотрены практики в клиниках, реабилитационных центрах, домах престарелых и международных учреждениях.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Старшая медицинская сестра в госпитале или частной клинике</li>
        <li>Руководитель отделения по уходу за пациентами</li>
        <li>Медицинская сестра с расширенными полномочиями</li>
        <li>Преподаватель сестринского дела в учебных заведениях</li>
        <li>Специалист по контролю качества ухода</li>
        <li>Консультант в области здравоохранения и общественного здоровья</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Профессия медицинской сестры — одна из самых востребованных в мировой системе здравоохранения.</p>
      <p>
        <strong>Средняя зарплата в Европе — от €35,000 до €70,000 в год,</strong> в зависимости от должности и страны.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с международным признанием</li>
        <li>Гибкая форма обучения: очная или дистанционная</li>
        <li>Практика в лучших клиниках Европы</li>
        <li>Индивидуальная академическая поддержка</li>
        <li>Модули по управлению, обучению и лидерству в медицине</li>
        <li>Программы на русском и английском языках</li>
      </ul>
      <h2>Учёба, приближенная к практике</h2>
      <p>
        Наши студенты развивают клинические и управленческие навыки, участвуют в программах обмена и исследовательских проектах. Выпускники
        готовы к карьерному росту и международной практике уже с первых лет после окончания.
      </p>
      <br/>
      <p className="padding-left">
        «Современная медицинская сестра — это эксперт, лидер и наставник. Мы обучаем тех, кто готов взять на себя ответственность за
        здоровье людей.»
      </p>
      <h2>Как поступить?</h2>
      <p>
        Подать заявку легко: заполните анкету онлайн, прикрепите необходимые документы — и мы свяжемся с вами. Приёмная комиссия
        сопровождает вас на каждом этапе: от первого звонка до начала обучения.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Высшее медсестринское дело — профессия, которая обеспечивает заботу и лидерство в медицине
    Высшее медсестринское образование — это путь к углубленным знаниям и расширенным профессиональным возможностям. Современная медицинская сестра — это не только помощник врача, но и самостоятельный специалист, обладающий клиническим мышлением, управленческими навыками и способностью принимать решения в критических ситуациях.
    Программа ориентирована на подготовку лидеров сестринского дела, способных не только оказывать квалифицированную помощь пациентам, но и управлять медицинским персоналом, обучать коллег, внедрять современные подходы в систему здравоохранения.

    Что вы будете изучать?
    • Основы сестринского дела и клинической практики
    • Внутренние болезни, хирургия, гериатрия и педиатрия
    • Менеджмент в здравоохранении и управление медперсоналом
    • Современные медицинские процедуры и стандарты ухода
    • Этические и правовые аспекты сестринской практики
    • Психология общения с пациентами и работа с семьями
    • Доказательная медицина и основы научных исследований
    • Профилактика и общественное здоровье
    В процессе обучения предусмотрены практики в клиниках, реабилитационных центрах, домах престарелых и международных учреждениях.

    Кем можно работать после окончания?
    • Старшая медицинская сестра в госпитале или частной клинике
    • Руководитель отделения по уходу за пациентами
    • Медицинская сестра с расширенными полномочиями
    • Преподаватель сестринского дела в учебных заведениях
    • Специалист по контролю качества ухода
    • Консультант в области здравоохранения и общественного здоровья

    Востребованность и доход
    Профессия медицинской сестры — одна из самых востребованных в мировой системе здравоохранения.
    Средняя зарплата в Европе — от €35,000 до €70,000 в год, в зависимости от должности и страны.

    Почему выбирают нас?
    • Европейский диплом с международным признанием
    • Гибкая форма обучения: очная или дистанционная
    • Практика в лучших клиниках Европы
    • Индивидуальная академическая поддержка
    • Модули по управлению, обучению и лидерству в медицине
    • Программы на русском и английском языках

    Учёба, приближенная к практике
    Наши студенты развивают клинические и управленческие навыки, участвуют в программах обмена и исследовательских проектах. Выпускники готовы к карьерному росту и международной практике уже с первых лет после окончания.
    «Современная медицинская сестра — это эксперт, лидер и наставник. Мы обучаем тех, кто готов взять на себя ответственность за здоровье людей.»

    Как поступить?
    Подать заявку легко: заполните анкету онлайн, прикрепите необходимые документы — и мы свяжемся с вами. Приёмная комиссия сопровождает вас на каждом этапе: от первого звонка до начала обучения. 
  `,
};
